export const ANSWER_TYPES = Object.freeze(
    {
        ONE: 'ONE',
        MULTIPLE: 'MULTIPLE',
        TEXT: 'TEXT',
        RATING: 'RATING',
    })

export const QUIZ_STATUS = Object.freeze({
    NEW: 'NEW',
    CONFIRMED: 'CONFIRMED',
    ORDERED: 'ORDERED',
    WAITING: 'WAITING',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED'
})

export const PRODUCT_TYPE = Object.freeze({
    SHAMPOO: 1,
    CONDITIONER: 2
})

export const HAIR_GOALS = Object.freeze([
        'Color',
        'Volume',
        'Both'
    ]
)

export const INTERNAL_USER_PERMISSIONS = Object.freeze({
    ADMIN: 'ADMIN',
    PACKER: 'PACKER',
    CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT'
})
